var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _circle2, _circle3, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPaymentV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 149,
    viewBox: "0 0 152 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21484 118.066L12.1504 106.915C15.7579 122.985 30.5161 134.682 37.7313 138.727L28.5484 142.335C17.3977 136.104 10.2919 123.75 8.21484 118.066Z",
    fill: "#004C74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32747 142.335C0.503291 140.138 1.98275 134.901 2.96663 132.496C3.25816 133.704 3.75281 134.695 4.2794 135.776C7.07087 141.505 12.4791 145.942 15.43 146.926C5.9192 151.518 2.31163 144.958 1.32747 142.335Z",
    fill: "#004C74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5973 76.0869L19.0381 89.8612C22.9736 109.801 43.0885 126.811 52.49 132.824L63.6407 128.233C60.7984 126.811 51.9767 122.372 41.6673 111.179C30.1887 98.7162 26.3625 83.4114 25.5973 76.0869Z",
    fill: "#004C74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16984 138.64C2.48223 132.408 19.8632 82.5585 34.9548 58.6174L91.6919 114.371C74.1133 125.653 16.2588 147.167 11.342 148.479C6.42511 149.79 -0.142539 144.871 1.16984 138.64Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1736 113.85C90.5518 115.452 88.2309 116.222 85.3889 116.214C82.5453 116.207 79.1985 115.421 75.5604 113.93C68.2851 110.949 59.8914 105.17 52.1141 97.2926C44.3367 89.4157 38.665 80.9491 35.7767 73.6364C34.3323 69.9796 33.5886 66.6231 33.6174 63.7797C33.6463 60.9378 34.4457 58.6269 36.0674 57.0256C37.6892 55.4243 40.0101 54.6544 42.8522 54.6617C45.6958 54.6691 49.0425 55.4554 52.6807 56.9462C59.956 59.9274 68.3497 65.7064 76.127 73.5833C83.9043 81.4603 89.576 89.9268 92.4644 97.2395C93.9088 100.896 94.6525 104.253 94.6236 107.096C94.5948 109.938 93.7954 112.249 92.1736 113.85Z",
    fill: "white",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4774 39.5957C40.8538 37.7591 43.0402 33.5831 44.4613 31.7246C42.4936 32.3805 39.2141 35.201 41.8378 41.2355C45.1174 48.7785 54.6282 43.8591 61.5154 43.8591C67.0251 43.8591 68.1839 47.1387 68.0746 48.7785L68.7305 45.8269C68.0746 43.5312 65.3853 38.8741 59.8756 38.6118C52.9884 38.2838 46.757 41.8914 43.4774 39.5957Z",
    fill: "#BCCDE6",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8764 111.523C88.3915 112.989 86.2653 113.696 83.6581 113.689C81.0494 113.682 77.9777 112.961 74.6371 111.592C67.957 108.855 60.2486 103.548 53.1056 96.3132C45.9626 89.0788 40.7543 81.3034 38.1022 74.589C36.776 71.2313 36.0936 68.1506 36.1201 65.5421C36.1465 62.935 36.8798 60.818 38.3647 59.3519C39.8496 57.8857 41.9757 57.1795 44.5829 57.1862C47.1916 57.193 50.2634 57.9144 53.6039 59.2833C60.2841 62.0206 67.9925 67.3275 75.1354 74.562C82.2784 81.7964 87.4868 89.5718 90.1389 96.2862C91.4651 99.6439 92.1474 102.725 92.121 105.333C92.0945 107.94 91.3613 110.057 89.8764 111.523Z",
    fill: "#FBF7F2",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1377 132.408C3.90294 135.579 7.29638 142.728 15.4298 146.926M8.0571 117.978C9.91554 123.225 16.5841 135.426 28.3906 142.247M12.3206 106.827C13.6324 113.496 20.5852 129.194 37.9015 138.64M19.2077 89.7736C20.1916 97.2073 28.1939 116.207 52.3317 132.736M25.7669 75.6713C26.0949 86.6033 34.0971 112.403 63.4824 128.145",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6925 77.3112C49.3807 77.3112 48.3968 74.0316 48.0688 72.3918C57.5797 66.4885 64.7948 55.6658 67.0905 49.4346C68.9974 44.2587 65.6694 40.7983 63.483 39.5958C65.6694 40.2517 70.3701 42.8754 70.3701 50.7464C70.3701 59.9352 52.3323 77.3112 50.6925 77.3112Z",
    fill: "#DAE9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4613 33.6925C40.001 38.1528 42.4323 42.5252 44.2907 44.2743C41.2296 43.2905 37.4997 36.9721 40.1973 31.3968C44.1327 23.2633 57.7979 20.7927 64.1384 20.5741C65.7126 21.8859 65.8875 24.8376 65.7782 26.1494C59.219 26.4774 50.0366 28.1172 44.4613 33.6925Z",
    fill: "#DAE9FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6925 77.3112C49.3807 77.3112 48.3968 74.0316 48.0688 72.3918C57.5797 66.4885 64.7948 55.6658 67.0905 49.4346C68.9974 44.2587 65.6694 40.7983 63.483 39.5958C65.6694 40.2517 70.3701 42.8754 70.3701 50.7464C70.3701 59.9352 52.3323 77.3112 50.6925 77.3112Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4613 33.6925C40.001 38.1528 42.4323 42.5252 44.2907 44.2743C41.2296 43.2905 37.4997 36.9721 40.1973 31.3968C44.1327 23.2633 57.7979 20.7927 64.1384 20.5741C65.7126 21.8859 65.8875 24.8376 65.7782 26.1494C59.219 26.4774 50.0366 28.1172 44.4613 33.6925Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.892 103.548C94.4427 86.7565 70.1517 96.5516 61.1875 103.548L64.4671 105.844C97.2631 91.0854 114.317 106.5 117.597 108.139C120.22 109.451 120.22 105.625 119.892 103.548Z",
    fill: "#DAE9FF",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7461 76.327L72.9935 75.999C74.4761 77.5805 77.9962 80.2164 81.1783 79.3499L82.1763 78.9507C81.8494 79.1267 81.5157 79.258 81.1783 79.3499L78.8967 80.2625C76.601 80.6998 71.1569 80.5249 67.7461 76.327Z",
    fill: "#BCCDE6",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0315 60.2562C88.9326 58.4196 87.5333 59.491 87.096 60.2562L86.5977 58.0477C88.4561 57.1731 92.5009 56.0799 96.9348 60.2568C101.112 64.1917 103.652 64.6069 106.118 63.5364C98.5746 68.4558 93.6552 62.5519 91.0315 60.2562Z",
    fill: "#BCCDE7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.645 50.4184C112.808 48.0571 111.256 48.5599 110.709 49.1065L109.725 48.122C112.349 47.2475 115.618 45.418 119.394 49.1929C121.689 51.4884 124.483 54.3531 127.763 55.0092L124.156 55.3371C118.908 55.0092 116.94 53.37 114.645 50.4184Z",
    fill: "#BCCDE7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0315 60.2562C88.9326 58.4196 87.5333 59.491 87.096 60.2562L86.5977 58.0477C88.4561 57.1731 92.5009 56.0799 96.9348 60.2568C101.112 64.1917 103.652 64.6069 106.118 63.5364C98.5746 68.4558 93.6552 62.5519 91.0315 60.2562Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.645 50.4184C112.808 48.0571 111.256 48.5599 110.709 49.1065L109.725 48.122C112.349 47.2475 115.618 45.418 119.394 49.1929C121.689 51.4884 124.483 54.3531 127.763 55.0092L124.156 55.3371C118.908 55.0092 116.94 53.37 114.645 50.4184Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.09 45.1703C131.239 55.4027 123.062 55.3371 118.58 54.0253C120.049 55.0965 124.628 56.9771 129.73 54.6812C136.289 51.7295 133.994 44.3505 133.338 44.1865C132.682 44.0225 129.402 44.7331 128.09 45.1703Z",
    fill: "#DAE9FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.773 48.4502C111.346 45.3319 115.567 46.5695 117.097 47.5534C105.589 45.5856 111.364 58.9449 107.101 62.8804C104.514 65.268 102.011 63.9514 100.87 63.2084C106.445 58.6169 101.355 52.1449 106.773 48.4502Z",
    fill: "#DAE9FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8481 62.2245C82.8975 56.19 89.5005 56.6492 92.6708 57.6331C82.504 57.6331 92.0148 73.3752 87.0954 78.2946C83.3203 82.0697 75.1185 80.5681 73.8066 80.0215C77.0298 80.6774 81.098 80.0688 82.176 77.9666C83.9873 74.4345 81.0257 66.9532 81.8481 62.2245Z",
    fill: "#DAE9FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.09 45.1703C131.239 55.4027 123.062 55.3371 118.58 54.0253C120.049 55.0965 124.628 56.9771 129.73 54.6812C136.289 51.7295 133.994 44.3505 133.338 44.1865C132.682 44.0225 129.402 44.7331 128.09 45.1703Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.773 48.4502C111.346 45.3319 115.567 46.5695 117.097 47.5534C105.589 45.5856 111.364 58.9449 107.101 62.8804C104.514 65.268 102.011 63.9514 100.87 63.2084C106.445 58.6169 101.355 52.1449 106.773 48.4502Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8481 62.2245C82.8975 56.19 89.5005 56.6492 92.6708 57.6331C82.504 57.6331 92.0148 73.3752 87.0954 78.2946C83.3203 82.0697 75.1185 80.5681 73.8066 80.0215C77.0298 80.6774 81.098 80.0688 82.176 77.9666C83.9873 74.4345 81.0257 66.9532 81.8481 62.2245Z",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.284 18.2777C116.284 19.5895 116.94 20.1224 117.596 20.5734C119.345 21.7761 122.187 24.1814 123.827 23.5255C124.925 23.0863 128.419 18.2781 126.779 17.6222C123.674 16.3801 122.515 14.9981 121.204 14.0142C119.892 13.0303 119.236 13.6862 118.58 14.3421C117.924 14.9981 116.284 16.6379 116.284 18.2777Z",
    fill: "#DAE9FF",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.853 73.4254C111.344 72.209 112.152 71.9604 112.929 71.7877C115.001 71.3273 118.537 70.1609 119.812 71.383C120.666 72.2013 122.106 77.9677 120.339 77.962C116.995 77.9513 115.404 78.7993 113.819 79.2205C112.234 79.6417 111.871 78.788 111.509 77.9342C111.146 77.0804 110.239 74.946 110.853 73.4254Z",
    fill: "#DAE9FF",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.998 40.5979C23.1469 41.5961 23.3002 42.4272 23.5067 43.196C24.0573 45.246 24.6595 48.9205 26.3328 49.4854C27.4532 49.8635 33.2313 48.4716 32.4091 46.9085C30.8521 43.9485 30.8675 42.1454 30.5076 40.5456C30.1478 38.9457 29.2231 39.0193 28.2984 39.0928C27.3737 39.1663 25.062 39.3501 23.998 40.5979Z",
    fill: "#DAE9FF",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 28.3787C109.374 28.9034 114.14 27.2855 116.327 26.4109C117.31 26.0172 118.95 25.2306 119.606 25.755C120.918 26.804 123.542 32.6427 123.214 33.2981C121.574 35.9223 112.391 38.2175 111.079 37.8895C109.768 37.5615 105.832 27.7227 107.8 28.3787Z",
    fill: "#FFF5DC",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.999 128.981C107.25 127.494 110.583 124.361 112.218 122.98C112.954 122.359 114.285 121.379 114.144 120.629C113.863 119.129 110.298 114.531 109.633 114.515C106.827 114.71 101.065 121.097 100.769 122.29C100.472 123.482 106.685 130.84 106.999 128.981Z",
    fill: "#FFF5DC",
    stroke: "#062E3F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6709,
    cy: 24.5096,
    r: 3.68552,
    fill: "#FB6F55",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.7031,
    cy: 40.2516,
    r: 3.68552,
    fill: "#004C74",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.306,
    cy: 111.091,
    r: 3.68552,
    fill: "#004C74",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6579 7.54C89.0217 5.88423 91.2918 5.66131 91.9707 7.21469L93.3132 10.2864C93.7036 11.1796 94.6247 11.7198 95.5948 11.6246L98.9311 11.2969C100.618 11.1313 101.532 13.2213 100.264 14.347L97.7576 16.5731C97.0288 17.2204 96.7997 18.2633 97.19 19.1565L98.5326 22.2282C99.2115 23.7816 97.506 25.2962 96.0437 24.4386L93.152 22.7426C92.3112 22.2495 91.2485 22.3539 90.5197 23.0011L88.0132 25.2272C86.7456 26.3529 84.7781 25.1989 85.1419 23.5432L85.8612 20.269C86.0704 19.3169 85.6428 18.3384 84.802 17.8453L81.9103 16.1494C80.448 15.2917 80.9375 13.0639 82.6246 12.8982L85.9609 12.5706C86.931 12.4753 87.7294 11.7662 87.9386 10.8142L88.6579 7.54Z",
    fill: "#FB6F55",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.557 81.1432C138.921 80.1365 140.776 81.4633 140.264 83.0795L140.056 83.737C139.762 84.6663 140.099 85.6794 140.892 86.2464L141.453 86.6476C142.832 87.6337 142.144 89.8082 140.449 89.821L139.759 89.8262C138.784 89.8335 137.925 90.4676 137.631 91.3969L137.423 92.0544C136.911 93.6706 134.63 93.6878 134.094 92.0795L133.876 91.4252C133.568 90.5004 132.699 89.8793 131.724 89.8866L131.035 89.8918C129.34 89.9045 128.618 87.7405 129.982 86.7338L130.537 86.3242C131.322 85.7454 131.644 84.7273 131.336 83.8026L131.118 83.1483C130.582 81.54 132.417 80.1854 133.796 81.1715L134.357 81.5727C135.15 82.1397 136.217 82.1317 137.002 81.5528L137.557 81.1432Z",
    fill: "#FB6F55",
    stroke: "#062E3F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPaymentV2);
export default __webpack_public_path__ + "static/media/SuccessPaymentV2.178cfa8f268c002f7a454b3e912f6aec.svg";
export { ForwardRef as ReactComponent };